import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';
import '../our_item_right/OurItemRight.css'
import OuritemReusable from '../index-Reusable/OuritemReusable';

function JustifiedExample() {
  return (
    <section id='our_item_right'>
      <Container>
        <Tabs defaultActiveKey="profile" id="justify-tab-example" className="mb-3" justify>
          <Tab eventKey="home" title="Top Rated">
            <div>
            <div class="row" >
            <OuritemReusable img="imeges/Raspberry.jpg" />
            <OuritemReusable img="imeges/kacha turmeric.png" />
            <OuritemReusable img="imeges/jamun.jpg" />
            <OuritemReusable img="imeges/avocado.jpg" />
            <OuritemReusable img="imeges/yellow orange.jpg" />
            <OuritemReusable img="imeges/tomato.jpg" />
           </div>
            </div>
          </Tab>
          <Tab eventKey="profile" title="Best Selling">
            <div>
            <div class="row" >
            <OuritemReusable img="imeges/kacha turmeric.png" />
            <OuritemReusable img="imeges/Raspberry.jpg" />
            <OuritemReusable img="imeges/yellow orange.jpg" />
            <OuritemReusable img="imeges/avocado.jpg" />
            <OuritemReusable img="imeges/jamun.jpg" />
            <OuritemReusable img="imeges/tomato.jpg" />
           </div>
            </div>
          </Tab>
          <Tab eventKey="longer-tab" title="On Sale">
            <div>
            <div class="row" >
            <OuritemReusable img="imeges/jamun.jpg" />
            <OuritemReusable img="imeges/kacha turmeric.png" />
            <OuritemReusable img="imeges/Raspberry.jpg" />
            <OuritemReusable img="imeges/avocado.jpg" />
            <OuritemReusable img="imeges/tomato.jpg" />
            <OuritemReusable img="imeges/yellow orange.jpg" />
           </div>
            </div>
          </Tab>
        </Tabs>
      </Container>
    </section>
  );
}

export default JustifiedExample;

